import { ChangeEvent, useCallback } from 'react';
import { Box, Card, Checkbox, Title } from '@nimbus-ds/components';
import { ExternalLink } from 'commons/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import type { SettingsCheckoutFormProps } from '../../types';

export function AllowChangePaymentMethodCard({
  values: { checkoutAllowsChangePaymentMethod },
  onChange,
}: Readonly<SettingsCheckoutFormProps>) {
  const t = useTranslationConfigurations(
    'settingsCheckout.settingsCheckoutForm.allowChangePaymentMethodCard',
  );

  const handleChangeToggle = useCallback(
    ({ target: { name, checked } }: ChangeEvent<HTMLInputElement>) => {
      onChange({ name, value: checked });
    },
    [onChange],
  );

  return (
    <Card id="change_payment_method">
      <Card.Header>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box>
            <Title fontSize="h3">{t('title')}</Title>
          </Box>
        </Box>
      </Card.Header>

      <Card.Body>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gap="4"
        >
          <Checkbox
            name="checkoutAllowsChangePaymentMethod"
            label={t('labelText')}
            checked={!!checkoutAllowsChangePaymentMethod}
            onChange={handleChangeToggle}
          />
          <ExternalLink appearance="primary" href={t('linkHref')}>
            {t('linkText')}
          </ExternalLink>
        </Box>
      </Card.Body>
    </Card>
  );
}
